<div class="fuild-container login">
  <div class="row">
    <div class="col-md-8 banner" banner></div>
    <div class="col-md-4 form">
      <div class="p-5">
        <div class="brand-logo text-center">
          <img [src]="logo">
        </div>
        <br/>
        <alert></alert>
        @if (!token) {
          <div class="alert alert-danger" role="alert">This reset link is invalid. Please request a new password reset.</div>
        } @else if (!done) {
          <form class="login" [formGroup]="resetForm" (ngSubmit)="onSubmit()" novalidate>
            <div class="form-group">
              <input type="password" formControlName="password" autocomplete="new-password" aria-label="New password" class="form-control form-control-sm" [ngClass]="{ 'is-invalid': submitted && resetForm.controls.password.errors }" placeholder="New password" />
              @if (submitted && resetForm.controls.password.errors) {
                <div class="text-danger">
                  @if (resetForm.controls.password.errors.required) {
                    <div>Password is required</div>
                  }
                  @if (resetForm.controls.password.errors.minlength) {
                    <div>Password must be at least 8 characters</div>
                  }
                </div>
              }
            </div>
            <div class="form-group">
              <input type="password" formControlName="confirmPassword" autocomplete="new-password" aria-label="Confirm new password" class="form-control form-control-sm" [ngClass]="{ 'is-invalid': submitted && (resetForm.controls.confirmPassword.errors || resetForm.errors?.mismatch) }" placeholder="Confirm new password" />
              @if (submitted && resetForm.controls.confirmPassword.errors?.required) {
                <div class="text-danger">Please confirm your password</div>
              } @else if (submitted && resetForm.errors?.mismatch) {
                <div class="text-danger">Passwords do not match</div>
              }
            </div>
            <button type="submit" class="btn btn-sm btn-primary btn-icon-split btn-block" [disabled]="loading">
              <span class="icon text-white-50">
                <i class="fas fa-arrow-right"></i>
              </span>
              <span class="text">Set new password</span>
            </button>
          </form>
        }
        <hr>
        <div class="text-center float-left">
          <a class="small" [routerLink]="['/login']">Back to login</a>
        </div>
        @if (!done) {
          <div class="text-center float-right">
            <a class="small" [routerLink]="['/forgot-password']">Request a new link</a>
          </div>
        }
      </div>
    </div>
  </div>
</div>
